import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import { useMemo } from "react";
import useLibrary from "../../modules/user/hooks/use-library";
import sanitazeHTML from 'sanitize-html';
import './style.scss';
type Props = {
    libraryCode: string;
}

const defaultOutro = `
    <p style="text-align: center">Udało się Wam wykonać wszystkie zadania! Mamy nadzieję, że dzięki grze dowiedzieliście się, co oznacza hasło „Czytanie wzmacnia” i lepiej poznaliście swoją bibliotekę.</p>
    <p style="text-align: center">Dziękujemy za udział!</p>
`;

const EndGameContent: React.FC<Props> = ({ libraryCode }) => {

    const { library } = useLibrary(libraryCode);

    const outroDelta = useMemo(() => {
        try {
            return JSON.parse(library?.outro || '[]');
        } catch (e) {

        }

        return { ops: [] };
    }, [library]);

    const outro = useMemo(() => {
        const parser = new QuillDeltaToHtmlConverter(outroDelta.ops, {
            inlineStyles: true
        });

        return sanitazeHTML(parser.convert() || defaultOutro, {
            allowedTags: [
                "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
                "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
                "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
                "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
                "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
                "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
                "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr"
            ],
            disallowedTagsMode: 'discard',
            allowedAttributes: {
                a: ['href', 'name', 'target'],
                // We don't currently allow img itself by default, but this
                // would make sense if we did. You could add srcset here,
                // and if you do the URL is checked for safety
                img: ['src'],
                p: ['class', 'style']
            },
            // Lots of these won't come up by default because we don't allow them
            selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
            // URL schemes we permit
            allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
            allowedSchemesByTag: {},
            allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
            allowProtocolRelative: true,
            enforceHtmlBoundary: false
        });
    }, [outroDelta])

    return <div className="outro-content" dangerouslySetInnerHTML={{ __html: outro }}></div>
}

export default EndGameContent;
